<div class="terms-and-conditions">
  <div class="terms-and-conditions-header">
    <h3 [class]="titleClass">{{'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.BUSES_POLICIES.TITLE' | transloco}}</h3>
    <div>{{'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.HEADER_BUSES' | transloco}}</div>
  </div>
  <div class="terms-and-conditions-cont">
    <div class="buses-policies"  [class.fix-collapse]="collapseFirst">
      <div class="buses-header" (click)="toggleFirst()">
        <div class="header-title">
          <h4 class="title-card">{{'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.BUSES_POLICIES.CONTENT.CHANGES_TITLE' | transloco}}</h4>
        </div>
        <div class="icon-cont" [class.rotate-180]="collapseFirst"><i aria-hidden="true" class="icon-expand"></i></div>
      </div>
      <div class="policies-body" [class.collapse]="collapseFirst">
        <p>{{'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.BUSES_POLICIES.CONTENT.CHANGES_CONTENT' | transloco}}</p>
      </div>
    </div>
  </div>
  <div class="terms-and-conditions-cont">
    <div class="buses-policies"  [class.fix-collapse]="collapseSecond">
      <div class="buses-header" (click)="toggleSecond()">
        <div class="header-title">
          <h4 class="title-card">{{'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.BUSES_POLICIES.CONTENT.CANCELLATION_TITLE' | transloco}}</h4>
        </div>
        <div class="icon-cont" [class.rotate-180]="collapseSecond"><i aria-hidden="true" class="icon-expand"></i></div>
      </div>
      <div class="policies-body" [class.collapse]="collapseSecond">
        <p>{{'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.BUSES_POLICIES.CONTENT.CANCELLATION_CONTENT' | transloco}}</p>
      </div>
    </div>
  </div>
</div>
<div class="terms-and-conditions">
  <div class="terms-and-conditions-header">
    <h3 [class]="titleClass">{{'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.BUSES_POLICIES.CONTENT.INFORMATION_TITLE' | transloco}}</h3>
    <div>{{'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.BUSES_POLICIES.CONTENT.INFORMATION_SUBTITLE' | transloco}}</div>
  </div>
  <div class="terms-and-conditions-cont">
    <div class="buses-policies"  [class.fix-collapse]="collapseImportant">
      <div class="buses-header" (click)="toggleImportant()">
        <div class="header-title">
          <h4 class="title-card">{{ 'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.BUSES_POLICIES.CONTENT.INFORMATION_CONTENT_TITLE_SEC' | transloco}}</h4>
        </div>
        <div class="icon-cont" [class.rotate-180]="collapseImportant"><i aria-hidden="true" class="icon-expand"></i></div>
      </div>
      <div class="policies-body" [class.collapse]="collapseImportant">
        <p [innerHTML]="'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.BUSES_POLICIES.CONTENT.INFORMATION_CONTENT' | transloco"></p>
      </div>
    </div>
  </div>
</div>